<template>
  <div>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle=" Presupuesto mensual: Gastos variables"></ui-title-red>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Presupuesto mensual'" videoEmbed="ADMINISTRACIONDINERO33PresupuestoMensualGastosVariables.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 mt-4>
        <p>
          Para determinar sus gastos variables complete los siguientes cuadros:<br>
          Importante: Digite las cifras sin puntos ni comas
        </p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <ui-calculadora :formulario="gastosVariables" :nombresCols="nombres" :resultadoDiferencia="resultadoDiferencia" :resultadoTotal="resultadoTotal"></ui-calculadora>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      lista: [
        "La primera especifica el <strong>tipo de ingreso.</strong>",
        "En la segunda <strong>debe digitar el valor real que recibe durante el mes.</strong>",
        "La tercera columna es opcional y se refiere al dinero que usted espera que ingrese para un mes determinado",
        "La última columna calcula la diferencia automáticamente, en caso de haber diligenciado los Valores Planeados. "
      ],
      nombres: [
        "<span class='font-red'>Gastos variables mensuales</span>",
        "<span class='font-red'>Valor real,</span><br> (Lo efectivamente gastado durante el mes)",
        "<span class='font-red'>Valor planeado,</span><br> (El gasto esperado inicialmente en el presupuesto mensual)",
        "<span class='font-red'>Diferencia mensual</span>"
      ]
    };
  },
  computed: {
    gastosVariables() {
      return this.$store.state.gastosVariables;
    },
    resultadoDiferencia() {
      return this.$store.getters.gastosVariablesDiferencia;
    },
    resultadoTotal() {
      return this.$store.getters.gastosVariablesTotal;
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-33.vue?7c7e2edb